import { createBrowserClient } from '@supabase/ssr';
import { Database } from '@/types_db';
import {logger} from '@/lib/logger';

// 使用单例模式存储客户端实例
let supabaseInstance: ReturnType<typeof createBrowserClient<Database>> | null = null;

// 定义一个函数来创建或返回已有的 Supabase 客户端实例
export const createClient = () => {
  if (supabaseInstance) {
    logger.info("createClient: Returning existing supabase instance");
    return supabaseInstance;
  }
  
  supabaseInstance = createBrowserClient<Database>(
    // 从环境变量中获取 Supabase URL 和匿名密钥
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
  
  return supabaseInstance;
};
